module.exports = __webpack_public_path__ + "static/img/live-gba.2603da54.jpg";